import { render, staticRenderFns } from "./VideoCallMinimized.vue?vue&type=template&id=9589c6a0&scoped=true&"
import script from "./VideoCallMinimized.vue?vue&type=script&lang=ts&"
export * from "./VideoCallMinimized.vue?vue&type=script&lang=ts&"
import style0 from "./VideoCallMinimized.vue?vue&type=style&index=0&id=9589c6a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9589c6a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VImg,VRow,VSpacer})
